import { isEmpty } from 'lodash';

const needsValidation = (field) => {
    return !isEmpty(field, "validation");
};

const validateField = (field, value) => {
    if (!isEmpty(field, "validation")) {
        if (field.validation === "integer") {
            return /^[0-9]+$/g.test(value);
        }
        else if (field.validation === "real-number" || field.validation === "number") {
            return /^[0-9]*(.([0-9]+))?$/g.test(value);
        }
        else if (field.validation === "single-word") {
            return /^[a-zA-Z-]+$/g.test(value);
        }
        else if (field.validation === "multiple-words-no-digits") {
            return /^[a-zA-Z-\s]*$/g.test(value);
        }
        else if (field.validation === "multiple-words") {
            return /^[a-zA-Z0-9-\s]*$/g.test(value);
        }
        else if (field.validation === "email-address") {
            return /^[\w.+]+@[a-zA-Z0-9-]+?\.[a-zA-Z.]+$/g.test(value);
        }
        else if (field.validation === "us-zip-code") {
            return /^[0-9]{5}(-[0-9]{4})?$/g.test(value);
        }
        else if (field.validation === "date") {
            return /^[0-9]{1,2}-[0-9]{1,2}-[0-9]{4}$/g.test(value);
        }
        else if (field.validation === "date-no-separator") {
            return /^[0-9]{8}$/g.test(value);
        }
        else {
            let re = new RegExp(field.validation, "g");
            return re.test(value);
        }
    }
    return true;
};

export {
    needsValidation,
    validateField
};
